import { gql } from "@apollo/client";

export default gql`
  mutation sendAccountPhoneNumberVerificationCode($organizationId: Int!) {
    sendPhoneNumberVerificationCode(organizationId: $organizationId) {
      membership {
        id
        phoneNumber
        phoneNumberVerified
        phoneNumberVerifiedAt
      }
    }
  }
`;
